import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent {
  colors: { [key: string]: string } = {
    primary: '#333333',
    dangerRed: '#c0392b',
    success: '#27ae60',
    white: '#ffffff',
    arrowGray: '#919199',
    successBlue: '#2980b9',
    warn: '#f39c12',
    lightGray: '#6a6a6a',
    closeGray: '#969696',
    accentGray: '#d9d9d9'
  };

  @Input()
  set src(src: string) {
    this.svgIconUrl = src ? `url('${src}')` : 'initial';
  }
  @HostBinding('style.--svg-icon-url') private svgIconUrl?: string;

  @Input()
  set color(color: string) {
    this.svgIconColor = color ? this.colors[color] : '';
  }

  @Input()
  set ativo(condition: boolean) {
    this.svgIconColor = condition
      ? this.colors['success']
      : this.colors['dangerRed'];
  }

  @HostBinding('style.--svg-icon-color') private svgIconColor?: string;

  @Input() @HostBinding('style.--svg-icon-size') size?: string;
  @Input() @HostBinding('style.--svg-icon-position') position?: string;
  @Input() @HostBinding('style.--svg-icon-repeat') repeat?: string;
  @Input() @HostBinding('style.--svg-icon-width') width?: string;
  @Input() @HostBinding('style.--svg-icon-height') height?: string;
}
